/* Free Gretzky guide auto-add (Sprunger Originals). Config comes from snippets/free-gretzky-guide.liquid. */
(function () {
  'use strict';
  var cfgEl = document.getElementById('sgg-config');
  if (!cfgEl || window.__sggLoaded) return;
  window.__sggLoaded = true;

  var C;
  try { C = JSON.parse(cfgEl.textContent); } catch (e) { return; }
  var qualifying = (C.qualifying || []).map(Number);
  var AUTO_KEY = 'sggAutoAdded';
  var DISMISS_KEY = 'sggDismissed';
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var origFetch = window.fetch.bind(window);
  var running = false, pending = false, timer = null;

  function ss(k, v) {
    try {
      if (v === undefined) return sessionStorage.getItem(k);
      if (v === null) sessionStorage.removeItem(k); else sessionStorage.setItem(k, v);
    } catch (e) { return null; }
  }
  function isCartMutation(url) {
    return /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(String(url || ''));
  }
  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(reconcile, 350);
  }

  // Watch every cart change made by the theme or apps (fetch and XHR). Our own calls use origFetch, so they are not seen here (no loops).
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = origFetch(input, init);
    if (isCartMutation(url)) p.then(schedule, function () {});
    return p;
  };
  var xOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (isCartMutation(url)) this.addEventListener('load', schedule);
    return xOpen.apply(this, arguments);
  };
  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function (e) { if (!e || e.source !== 'sgg') schedule(); });
  }

  function sectionIds() {
    var ids = [];
    if (document.querySelector('cart-drawer')) ids.push('cart-drawer');
    if (document.getElementById('cart-icon-bubble')) ids.push('cart-icon-bubble');
    var items = document.getElementById('main-cart-items');
    var footer = document.getElementById('main-cart-footer');
    if (items && items.dataset.id) ids.push(items.dataset.id);
    if (footer && footer.dataset.id) ids.push(footer.dataset.id);
    return ids;
  }
  function parse(html) { return new DOMParser().parseFromString(html, 'text/html'); }

  function refresh(sections, cart) {
    if (!sections) return;
    var onCartPage = !!document.getElementById('main-cart-items');
    if (onCartPage && cart && cart.item_count === 0) { window.location.reload(); return; }
    var drawer = document.querySelector('cart-drawer');
    if (drawer && sections['cart-drawer']) {
      var d = parse(sections['cart-drawer']);
      var src = d.querySelector('#CartDrawer'), tgt = document.getElementById('CartDrawer');
      if (src && tgt) tgt.innerHTML = src.innerHTML;
      var srcDrawer = d.querySelector('cart-drawer');
      if (srcDrawer) drawer.classList.toggle('is-empty', srcDrawer.classList.contains('is-empty'));
      var overlay = drawer.querySelector('#CartDrawer-Overlay');
      if (overlay && drawer.close) overlay.addEventListener('click', drawer.close.bind(drawer));
    }
    if (sections['cart-icon-bubble']) {
      var bubble = document.getElementById('cart-icon-bubble');
      var b = parse(sections['cart-icon-bubble']).querySelector('.shopify-section');
      if (bubble && b) bubble.innerHTML = b.innerHTML;
    }
    [['main-cart-items'], ['main-cart-footer']].forEach(function (pair) {
      var el = document.getElementById(pair[0]);
      if (!el || !el.dataset.id || !sections[el.dataset.id]) return;
      var srcC = parse(sections[el.dataset.id]).querySelector('.js-contents');
      var tgtC = el.querySelector('.js-contents');
      if (srcC && tgtC) tgtC.innerHTML = srcC.innerHTML;
    });
  }

  function post(path, body) {
    body.sections = sectionIds().join(',');
    body.sections_url = window.location.pathname;
    return origFetch(root + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return origFetch(root + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); });
  }

  // Discount code that makes the guide free (optional). Applied only by this script, and only removed if this script applied it.
  var CODE = C.discountCode || '';
  var CODE_KEY = 'sggCodeApplied';
  function syncCode(cart) {
    if (!CODE) return cart;
    var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
    var entry = (cart.discount_codes || []).filter(function (d) { return d.code.toLowerCase() === CODE.toLowerCase(); })[0];
    var hasCode = !!entry;
    var guideLines = cart.items.filter(function (i) { return Number(i.variant_id) === Number(C.guideVariantId) || Number(i.product_id) === Number(C.guideProductId); });
    var autoLine = guideLines.filter(function (i) { return i.properties && i.properties._sgg_auto; })[0];
    var next = null;
    // Never push out a code the customer entered (e.g. HOF2026): these codes do not combine.
    var otherActive = (cart.discount_codes || []).some(function (d) { return d.applicable && d.code.toLowerCase() !== CODE.toLowerCase(); });
    if (autoLine && guideLines.length === 1 && !hasCode && !otherActive && (C.codeMode === 'always' || autoLine.final_line_price > 0)) {
      next = codes.concat([CODE]);
      ss(CODE_KEY, '1');
    } else if (hasCode && ss(CODE_KEY) === '1' && (!guideLines.length || entry.applicable === false)) {
      // Only take out a code this script applied, and only once it no longer does anything.
      if (entry.applicable === false && C.codeMode === 'always' && autoLine) return cart;
      next = codes.filter(function (c) { return c.toLowerCase() !== CODE.toLowerCase(); });
      ss(CODE_KEY, null);
    }
    if (!next) return cart;
    return post('cart/update.js', { discount: next.join(',') }).then(function (res) {
      if (res && res.sections) sections = res.sections;
      return res && res.items ? res : getCart();
    });
  }

  // Never leave a paid copy of the "free" guide in the cart. If the guide cannot be made $0
  // (e.g. the customer used HOF2026, which does not combine with the guide code), take our copy
  // out and do not add it again until the cart's discount codes change.
  var BLOCK_KEY = 'sggBlockedFor';
  function codeSig(cart) {
    return (cart.discount_codes || []).filter(function (d) { return d.applicable; })
      .map(function (d) { return d.code.toLowerCase(); }).sort().join(',');
  }
  function enforceFree(cart) {
    if (!cart || !cart.items) return cart;
    var paid = cart.items.filter(function (i) { return i.properties && i.properties._sgg_auto && i.final_line_price > 0; });
    if (!paid.length) return cart;
    ss(AUTO_KEY, null);
    ss(BLOCK_KEY, codeSig(cart));
    var chain = Promise.resolve();
    paid.forEach(function (line) {
      chain = chain.then(function () { return post('cart/change.js', { id: line.key, quantity: 0 }); })
        .then(function (res) { sections = res.sections || sections; return res; });
    });
    return chain.then(function () { return getCart(); }).then(syncCode);
  }

  var sections = null;
  function reconcile() {
    if (running) { pending = true; return; }
    running = true;
    sections = null;
    getCart()
      .then(function (cart) {
        var hasQualifying = cart.items.some(function (i) { return qualifying.indexOf(Number(i.product_id)) !== -1; });
        var guideLines = cart.items.filter(function (i) { return Number(i.variant_id) === Number(C.guideVariantId) || Number(i.product_id) === Number(C.guideProductId); });
        var autoLines = guideLines.filter(function (i) { return i.properties && i.properties._sgg_auto; });
        var ownLines = guideLines.filter(function (i) { return !(i.properties && i.properties._sgg_auto); });
        var chain = Promise.resolve();

        if (autoLines.length) {
          if (!hasQualifying || ownLines.length) {
            // No card left, or the customer added the guide themselves: take our copy out.
            ss(AUTO_KEY, null);
            autoLines.forEach(function (line) {
              chain = chain.then(function () { return post('cart/change.js', { id: line.key, quantity: 0 }); })
                .then(function (res) { sections = res.sections || sections; return res; });
            });
          } else {
            ss(AUTO_KEY, '1');
          }
        } else {
          if (ss(AUTO_KEY) === '1') {
            // Our guide is gone but we did not remove it: the customer took it out.
            ss(AUTO_KEY, null);
            if (hasQualifying) ss(DISMISS_KEY, '1');
          }
          var blocked = ss(BLOCK_KEY);
          if (blocked !== null && blocked !== codeSig(cart)) { ss(BLOCK_KEY, null); blocked = null; }
          if (hasQualifying && !guideLines.length && !C.owned && ss(DISMISS_KEY) !== '1' && blocked === null) {
            var props = { _sgg_auto: '1' };
            props[C.noteLabel || 'Offer'] = C.noteText || 'Free with your card purchase';
            chain = chain.then(function () {
              return post('cart/add.js', { items: [{ id: Number(C.guideVariantId), quantity: 1, properties: props }] });
            }).then(function (res) {
              if (res && !res.status) { ss(AUTO_KEY, '1'); sections = res.sections || sections; }
              return res;
            });
          }
        }
        return chain.then(function () { return getCart(); }).then(syncCode).then(enforceFree);
      })
      .then(function (newCart) {
        if (sections) refresh(sections, newCart);
      })
      .catch(function (e) { console.warn('[free-gretzky-guide]', e); })
      .finally(function () {
        running = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
})();
